// Checkbox com título e texto de ajuda — usado nos formulários do painel (sem disparos,
// embaixadora...). Mantém o mesmo visual dos inputs (accent do painel).
export const CheckboxField = ({ id, checked, onChange, label, help, disabled = false }) => (
  <label
    htmlFor={id}
    className={`flex items-start gap-3 rounded-md border border-gray-200 px-3 py-2.5 ${disabled ? 'opacity-60' : 'cursor-pointer hover:bg-gray-50'}`}
  >
    <input
      id={id}
      type="checkbox"
      className="mt-0.5 h-4 w-4 rounded border-gray-300 accent-[#7321DF]"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span className="min-w-0">
      <span className="block text-sm font-medium text-gray-800">{label}</span>
      {help && <span className="block text-xs text-gray-500 mt-0.5">{help}</span>}
    </span>
  </label>
);
